<template>
	<div>
		<div class="barcode-info-scan">
			<img src="https://cdn.orderonline.id/img/barcode-scanner.gif" class="w-100" alt="Ostock">
		</div>

		<ul role="tablist" class="nav nav-tabs nav-fill mt-3">
			<li class="nav-item" @click="tabbed('noReceipt')">
				<span class="nav-link" :class="{ 'active': type === 'noReceipt' }">{{ $t('barcode.noReceipt') }}</span>
			</li>
			<li class="nav-item" @click="tabbed('withReceipt')">
				<span class="nav-link" :class="{ 'active': type === 'withReceipt' }">{{ $t('barcode.withReceipt') }}</span>
			</li>
		</ul>
		<div>
			<div class="tab-content">
				<div class="" v-show="type === 'noReceipt'">
					<!-- form-read-scanner -->
					<div class="form-group form-read-scanner">
						<input
							class="form-control"
							id="barcode-no-receipt"
							type="text"
							ref="barcodeNoReceipt"
							v-model="codeNoReceipt"
							@change="readScannerNoReceipt"
							@blur="setFocus"
						>
					</div>

					<div class="mt-3 table-responsive" v-if="barcodeLists.length > 0">
						<table class="barcode-table table table-striped table-hover mb-0">
							<thead>
								<tr>
									<th width="5%">{{ $tc('barcode.number') }}</th>
									<th width="20%">{{ $tc('barcode.orderId') }}</th>
									<th>{{ $tc('barcode.name') }}</th>
									<th width="20%">{{ $tc('barcode.status') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in barcodeLists" :key="index">
									<td>{{ index + 1 }}</td>
									<td><a :href="`./orders/${item.order_id}`">#{{ item.order_id }}</a></td>
									<td>{{ item.name }}</td>
									<td class="va-m">
										<div class="pl-3" v-if="item.status === 'pending'">
											<span class="is-loading"></span>
										</div>
										<mark class="order-status status-completed" v-else-if="item.status === 'completed'"><span>completed</span></mark>
										<mark class="order-status status-cancelled" v-else-if="item.status === 'failed'"><span>failed</span></mark>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- Table Empty -->
					<div class="barcode-list-empty alert alert-warning text-center" role="alert" v-else>
						<span>{{ $tc('barcode.empty') }}</span>
					</div>
				</div>

				<div class="" v-show="type === 'withReceipt'">
					<!-- form-read-scanner -->
					<div class="form-group form-read-scanner">
						<input class="form-control" id="barcode-with-receipt" type="text" ref="barcodeWithReceipt" v-model="codeWithReceipt" @change="readScannerWithReceipt">
					</div>
					<div class="mt-3 table-responsive" v-if="barcodeReceiptList.length > 0">
						<table class="barcode-table table table-striped table-hover mb-0">
							<thead>
								<tr>
									<th width="3%">{{ $tc('barcode.number') }}</th>
									<th width="20%">{{ $tc('barcode.orderId') }}</th>
									<th>{{ $tc('barcode.name') }}</th>
									<th width="30%">{{ $tc('barcode.receipt') }}</th>
									<th width="20%">{{ $tc('barcode.status') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in barcodeReceiptList" :key="index">
									<td>{{ index + 1 }}</td>
									<td><a :href="`./orders/${item.order_id}`">#{{ item.order_id }}</a></td>
									<td>{{ item.name }}</td>
									<td class="field-receipt">
										<div v-if="item.receipt === ''">
											<input
												type="text"
												class="form-control input-receipt"
												ref="receiptNumber"
												v-model="receiptNumber"
												v-on:keyup.enter="setReceipt(item.order_id)"
												@blur="setFocusReceiptNumber">
										</div>
										<div class="fill-receipt" v-else>{{ item.receipt }}</div>
									</td>
									<td class="va-m">
										<div class="pl-3" v-if="isProcessing">
											<span class="is-loading"></span>
										</div>
										<div v-else>
											<div class="pl-3" v-if="item.status === 'scanning'"><span>-</span></div>
											<mark class="order-status status-completed" v-else-if="item.status === 'completed'"><span>completed</span></mark>
											<mark class="order-status status-cancelled" v-else-if="item.status === 'failed'"><span>failed</span></mark>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- Table Empty -->
					<div class="barcode-list-empty alert alert-warning text-center" role="alert" v-else>
						<span>{{ $tc('barcode.emptyReceipt') }}</span>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { getAxiosErrorMessage } from '../lib/helper';
import submissionsApi from '../api/submissions';

export default {
	name: 'barcodeScanner',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isProcessing: false,
			codeNoReceipt: '',
			codeWithReceipt: '',
			barcodeLists: [],
			barcodeReceiptList: [],
			type: 'noReceipt',
			receiptNumber: '',
		};
	},
	created() {},
	mounted() {
		this.setFocus();
	},
	methods: {
		// trigger tab
		tabbed(type) {
			this.type = type;
			this.setFocus();
		},

		// auto focus
		setFocus() {
			if (this.show && this.$refs.barcodeNoReceipt && this.type === 'noReceipt') {
				this.$nextTick(() => this.$refs.barcodeNoReceipt.focus());
			} else if (this.show && this.$refs.barcodeWithReceipt && this.type === 'withReceipt') {
				this.$nextTick(() => this.$refs.barcodeWithReceipt.focus());
			}
		},

		setFocusReceiptNumber() {
			if (this.show && this.type === 'withReceipt') {
				this.$nextTick(() => {
					// const index = this.barcodeReceiptList.length - 1;
					const input = this.$refs.receiptNumber[0];
					if (input) input.focus();
				});
			}
		},

		// read barcode scan no receipt
		readScannerNoReceipt() {
			const value = this.codeNoReceipt;
			const code = {
				order_id: value,
				name: '-',
				status: 'pending',
			};

			this.appendBarcodeNoReceiptList(code);
		},

		// append barode value to list no receipt
		appendBarcodeNoReceiptList(code) {
			this.codeNoReceipt = '';
			const isExist = this.barcodeLists.findIndex(el => (el.order_id === code.order_id));
			if (isExist === -1) {
				// this.barcodeLists.push(code);
				this.barcodeLists.unshift(code);
				this.doUpdateStatus(code.order_id);
			}
		},

		// read barcode scan no receipt
		readScannerWithReceipt() {
			const value = this.codeWithReceipt;
			const code = {
				order_id: value,
				name: '-',
				status: 'scanning',
				receipt: '',
			};

			this.appendBarcodeWithReceiptList(code);
		},

		// append barcode value to list with receipt
		appendBarcodeWithReceiptList(code) {
			this.codeWithReceipt = '';
			const isExist = this.barcodeReceiptList.findIndex(el => (el.order_id === code.order_id));
			if (isExist === -1) {
				this.checkOrderid(code);
			}
		},

		// do check order id for barcode scanner with receipt number
		checkOrderid(code) {
			const id = code.order_id;
			const params = `${id}?minimal=1`;

			const callback = (response) => {
				code.name = response.data.customer_data.name;
				// this.barcodeReceiptList.push(code);
				this.barcodeReceiptList.unshift(code);
				this.setFocusReceiptNumber();
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
				// this.isProcessing = false;
			};

			submissionsApi.getDetails(params, callback, errorCallback);
		},

		// set receipt number
		setReceipt(orderId) {
			this.doUpdateStatus(orderId);
		},

		doUpdateStatus(orderId) {
			this.isProcessing = true;
			const status = 'completed';
			const params = { status };

			if (this.type === 'withReceipt') {
				params.receipt_number = this.receiptNumber;
			}

			// Update Progress
			const callback = (response) => {
				const name = response.data.customer_data.name;
				const receiptNumber = response.data.shipping.receipt_number;
				const payload = {
					order_id: orderId,
					status: 'completed',
					receipt_number: receiptNumber,
				};

				this.$emit('change', payload);
				this.isProcessing = false;

				if (this.type === 'noReceipt') {
					this.barcodeLists = this.barcodeLists.map((el) => {
						if (el.order_id === orderId) {
							el.name = name;
							el.status = 'completed';
						}
						return el;
					});
				} else if (this.type === 'withReceipt') {
					this.barcodeReceiptList = this.barcodeReceiptList.map((el) => {
						if (el.order_id === orderId) {
							el.receipt = receiptNumber;
							el.status = 'completed';
						}
						return el;
					});
					this.receiptNumber = '';
					this.setFocus();
				}
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isProcessing = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});

				if (this.type === 'noReceipt') {
					this.barcodeLists = this.barcodeLists.map((el) => {
						if (el.order_id === orderId) {
							el.status = 'failed';
						}
						return el;
					});
				} else if (this.type === 'withReceipt') {
					this.receiptNumber = '';
					this.setFocus();
				}
			};

			submissionsApi.setStatus(orderId, params, callback, errorCallback);
		},
	},
	watch: {
		type() {
			this.setFocus();
		},
	},
};
</script>

<style scoped>
.form-read-scanner {
	opacity: 0;
	height: 0;
}

.barcode-table {
	border: 1px solid #ddd;
}

.barcode-info-scan {
	margin: -24px -24px 0 -24px;
}


.barcode-list-empty {
	padding: 1.3em 1.3em;
}

.va-m {
	vertical-align: middle !important;
}

.input-receipt {
	padding: .12rem .6rem;
}


.fill-receipt {
	padding-top: .1rem;
}

.tab-content {
	border: 1px solid #ddd;
	margin-top: -1px;
	padding: .5rem;
}

.alert {
	margin-bottom: 0;
}
</style>
